import { NgModule } from '@angular/core';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import {
  NbLayoutModule,
  NbSpinnerModule,
  NbTreeGridModule,
  NbMenuModule,
  NbUserModule,
  NbContextMenuModule,
  NbSidebarModule,
  NbCardModule,
  NbDialogModule,
  NbButtonGroupModule,
  NbButtonModule,
  NbInputModule,
  NbIconModule,
  NbDatepickerModule,
  NbSelectModule,
  NbAutocompleteModule,
  NbProgressBarModule, 
  NbToastrModule, 
  NbToastrConfig, 
  NbTimepickerModule,
  NbTabsetModule,
  NbCheckboxModule
} from '@nebular/theme';
import { NbPasswordAuthStrategy, NbAuthModule, NbAuthJWTToken } from '@nebular/auth';
import { environment } from '@environments/environment';

@NgModule({
  declarations: [],
  imports: [
    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: 'email',
          token: {
            class: NbAuthJWTToken,
            key: 'accessToken'
          },
          baseEndpoint: environment.api.baseUrl,
          login: {
            endpoint: '/auth/login',
            method: 'post',
          },
          logout: {
            endpoint: '/auth/logout',
            method: 'post',
            requireValidToken: true,
          }
        }),
      ],
      forms: {
        login: {
          redirectDelay: 500,
          strategy: 'email',
          redirect: {
            success: 'dashboard',
            failure: null,
          },
          showMessages: {
            success: true,
            error: true,
          },
        },
        logout: {
          redirectDelay: 500,
          strategy: 'email',
          redirect: {
            success: '/auth/login',
            failure: null,
          },
          showMessages: {
            success: true,
            error: true,
          },
        }
      },
    }),
    NbSpinnerModule,
    NbLayoutModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDialogModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbTimepickerModule.forRoot(),
    NbUserModule,
    NbEvaIconsModule,
    NbIconModule,
    NbCardModule,
    NbTreeGridModule,
    NbContextMenuModule,
    NbInputModule,
    NbSelectModule,
    NbAutocompleteModule,
    NbButtonModule,
    NbButtonGroupModule,
    NbProgressBarModule,
    NbToastrModule.forRoot({ position: 'bottom-right', duration: 3000 } as Partial<NbToastrConfig>),        
    NbTabsetModule,
    NbCheckboxModule
  ],
  exports: [
    NbLayoutModule,
    NbSpinnerModule,
    NbSidebarModule,
    NbMenuModule,
    NbDialogModule,
    NbDatepickerModule,
    NbTimepickerModule,
    NbUserModule,
    NbEvaIconsModule,
    NbIconModule,
    NbCardModule,
    NbTreeGridModule,
    NbContextMenuModule,
    NbInputModule,
    NbSelectModule,
    NbAutocompleteModule,
    NbButtonModule,
    NbButtonGroupModule,
    NbProgressBarModule,
    NbToastrModule,
    NbTabsetModule,
    NbCheckboxModule
  ],
})
export class NebularModule { }
